import router, { resetRouter } from '@/router/index'
import url from "@/api/url.js"
import {
  post,
} from "@/api/http.js";

const state = {
  // 当前班级
  currentClass: {
    // classCode: "7n3b",
    // classId: 4,
    // className: "七年三班",
    // createBy: "1",
    // createTime: "2021-12-17 16:24:21",
    // delFlag: "0",
    // gradeCode: "cxzxqnj",
    // gradeId: 2,
    // gradeName: "七年级",
    // id: 16,
    // isCharge: 0,
    // remark: null,
    // schoolId: 1,
    // schoolName: "广州市长兴中学",
    // status: "0",
    // teacherId: 5,
    // teacherName: "李倩",
    // teacherNumber: "HS1003",
    // updateBy: "1",
    // updateTime: "2021-12-17 16:24:21",
  },
  // 班级列表
  classList: [
    // {
    //   classCode: "7n1b",
    //   classId: 1,
    //   className: "七年一班",
    //   classroomName: null,
    //   courseId: 3,
    //   courseName: "英语",
    //   courseTimes: null,
    //   gradeCode: "cxzxqnj",
    //   gradeId: 2,
    //   gradeName: "七年级",
    //   isCharge: 0,
    //   lessons: null,
    //   schoolId: 1,
    //   schoolName: "广州市长兴中学",
    //   teaHead: "http://192.168.18.98:8900/profile/upload/2022/01/05/3d088d4f-250b-4480-973f-3478cc929227.jpeg",
    //   teacherId: 5,
    //   teacherName: "李倩11",
    //   titles: null,
    //   week: null,
    // }, {
    //   classCode: "7n2b",
    //   classId: 2,
    //   className: "七年二班",
    //   classroomName: null,
    //   courseId: 3,
    //   courseName: "英语",
    //   courseTimes: null,
    //   gradeCode: "cxzxqnj",
    //   gradeId: 1,
    //   gradeName: "七年级",
    //   isCharge: 0,
    //   lessons: null,
    //   schoolId: 1,
    //   schoolName: "广州市长兴中学",
    //   teaHead: "http://192.168.18.98:8900/profile/upload/2022/01/05/3d088d4f-250b-4480-973f-3478cc929227.jpeg",
    //   teacherId: 5,
    //   teacherName: "李倩11",
    //   titles: null,
    //   week: null,
    // },
    // {
    //   classCode: "7n1b",
    //   classId: 4,
    //   className: "七年三班",
    //   classroomName: null,
    //   courseId: 3,
    //   courseName: "英语",
    //   courseTimes: null,
    //   gradeCode: "cxzxqnj",
    //   gradeId: 2,
    //   gradeName: "七年级",
    //   isCharge: 0,
    //   lessons: null,
    //   schoolId: 1,
    //   schoolName: "广州市长兴中学",
    //   teaHead: "http://192.168.18.98:8900/profile/upload/2022/01/05/3d088d4f-250b-4480-973f-3478cc929227.jpeg",
    //   teacherId: 5,
    //   teacherName: "李倩11",
    //   titles: null,
    //   week: null,
    // },
  ],
}

const mutations = {
  // 班级列表
  SET_CLASS_LIST: (state, data) => {
    state.classList = data
    console.log("classInfo.classList", state.classList)
  },
  // 当前班级
  SET_CURRENT_CLASS: (state, i) => {
    state.currentClass = state.classList[i]
    console.log("classInfo.currentClass", state.currentClass)
  },
  // 班级列表添加班级
  // ADD_CLASS: (state, item) => {
  //   state.classList.push(item)
  // },
  // 班级列表删除绑定班级
  DELETE_CLASS: (state, i) => {
    state.classList.splice(i, 1)
    // console.log("classInfo.classList=>", state.classList)
  }
}

const actions = {
  // 获取班级信息
  getClassInfo({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      // 调用获取班级信息接口
      post(url.selectTeacherListByClassIdPC, {
        teacherId: payload.id
      }).then(res => {
        // console.log(res)
        if (res.code == 200) {
          let list = res.data || []
          // 班级列表
          commit('SET_CLASS_LIST', list)
          if (list.length) {
            // 设置当前班级，基于角色修改可访问的菜单
            this.dispatch('classInfo/setCurrentClass', 0)
            for (let i = 0; i < list.length; i++) {
              if (list[i].isCharge == 1) {
                if (i != 0) {
                  this.dispatch('classInfo/setCurrentClass', i)
                }
                break
              }
            }
          }
          resolve(list)
        } else {
          reject('获取绑定的班级信息失败')
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 设置当前班级，基于角色修改可访问的菜单
  setCurrentClass({ commit, dispatch, state }, index) {
    // 切换班级前跳转回首页
    // router.push("/welcome"); 
    // router.push("/bind-class"); 
    // console.log(index)
    // 设置当前班级
    commit('SET_CURRENT_CLASS', index)
    // let roleId = ''

    // 根据班级的 isCharge（0：科任老师,1:班主任）来的角色生成菜单
    if (state.currentClass.courseList && state.currentClass.courseList.length) {
      // 有科目 21：班主任(有科目) 31：科任老师(有科目)
      // roleId = state.currentClass.isCharge ? 21 : 31
    } else {
      // 无科目 20：班主任(无科目) 30：科任老师(无科目)
      // roleId = state.currentClass.isCharge ? 20 : 30
    }
    // console.log(roleId)
    try {
      // 重置路由
      resetRouter()
      // 基于角色生成可访问的菜单
      // let accessRoutes = []
      // this.dispatch('permission/generateRoutes', roleId).then(res => {
      //   accessRoutes = res
      //   // console.log("accessRoutes=>", accessRoutes)
      //   // 动态添加可访问的路由
      //   router.addRoutes(accessRoutes)
      //   for (let item of accessRoutes) {
      //     router.addRoute(item)
      //   }
      //   // 页面刷新
      //   this.commit('common/reload')
      // })
    } catch (error) {

    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
